import { Data, HomeData, BarData } from "../utils/pagesData";

export const homeDataEmpty: HomeData = {
  carousel: [],
  bars: [],
};

export const barDataEmpty: BarData = {
  mainInfo: {
    barName: "",
    page: "",
    icon: "",
    communication: [],
    contacts: [],
    workingTime: [],
    coordinates: {
      lat: 0,
      lot: 0,
    },
  },
  menuPage: {
    icon: "",
    carousel: [],
    totalMenu: [],
    detailsMenu: [],
  },
  biznesLanchPage: {
    image: "",
  },
  aboutUsPage: {
    description: {
      image: "",
      title: "",
      texts: [],
    },
    menuBlock: {
      rows: [],
    },
    atmosphere: [],
  },
};

export const dataEmpty: Data = {
  Home: homeDataEmpty,
  GolodniiKrolik: barDataEmpty,
  MLounge: barDataEmpty,
  // LetItBe: barDataEmpty,
};
